// snackbarService.js

let showFn = null;
let clearFn = null;
let autoCloseFn = null;

export const registerSnackbar = (
  show,
  clear,
  autoClose
) => {
  showFn = show;
  clearFn = clear;
  autoCloseFn = autoClose;
};

const success = (
  message,
  duration = 3000,
  waitForAction = false
) => {
  showFn?.({
    message,
    type: "success",
    duration,
    waitForAction,
  });
};

const error = (
  message,
  duration = 5000,
  waitForAction = false
) => {
  showFn?.({
    message,
    type: "error",
    duration,
    waitForAction,
  });
};

const warning = (
  message,
  duration = 4000,
  waitForAction = false
) => {
  showFn?.({
    message,
    type: "warning",
    duration,
    waitForAction,
  });
};

const info = (
  message,
  duration = 3000,
  waitForAction = false
) => {
  showFn?.({
    message,
    type: "info",
    duration,
    waitForAction,
  });
};

// after api/button/navigation
const triggerAutoClose = () => {
  autoCloseFn?.();
};

// manual close
const close = () => {
  clearFn?.();
};

export const snackbar = {
  success,
  error,
  warning,
  info,
  triggerAutoClose,
  close,
};